import React, { useEffect, useState } from "react";
import { AddFlex, Gap } from "../reusableStyles";
import { BoxedTabs } from "../Pages/OfferingsPages/OfferingPagesTabHeader";
import useWindowSize from "../Hooks/useWindowSize";
import { Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { Outlet, useNavigate } from "react-router";
import {
  CREATE_INSTAGRAM_CAMPAIGNS,
  INSTAGRAM_COLLABORATIONS,
  INSTAGRAM_MANAGED_CAMPAIGNS,
  INSTAGRAM_MY_CAMPAIGNS,
} from "../OnboardingPage/routeNames";
import { useSelector } from "react-redux";
import { callNonStoreApi } from "../NonStoreApis";
import { AuthorisedCampaignCreators } from "../Api/ApiEndPoints";
import { isArrayNullOrUndefined } from "../utils";

function InstagramCampagins() {
  const { isMobileView } = useWindowSize();
  const { apiUserData } = useSelector((state) => state.user);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [tabs, setTabs] = useState([]);
  const [selectedTabIndex, setSelectedTabIndex] = useState(
    window.location.pathname.includes(INSTAGRAM_MANAGED_CAMPAIGNS)
      ? 2
      : window.location.pathname.includes(INSTAGRAM_COLLABORATIONS)
      ? 1
      : 0
  );

  const getAction = () => {
    if (selectedTabIndex === 0 && tabs.length > 2) {
      return (
        <Button
          onClick={() => {
            // navigate(CAMPAIGN_PRICING_PAGE);
            navigate(CREATE_INSTAGRAM_CAMPAIGNS);
          }}
          icon={<PlusOutlined />}
          type="primary"
        >
          New Campaign
        </Button>
      );
    }
    return null;
  };

  const handleSetInitialTabs = async () => {
    try {
      const response = await callNonStoreApi(AuthorisedCampaignCreators);
      const authorisedCampaignCreators = response.data.data;
      let tabs, tabIndex;
      if (authorisedCampaignCreators.includes(apiUserData.userId)) {
        tabs = ["My Campaigns", "Collaborations", "Managed Campaigns"];
      } else {
        tabs = ["Collaborations", "Managed Campaigns"];
      }
      if (tabs.length > 2) {
        window.location.pathname.includes(INSTAGRAM_MANAGED_CAMPAIGNS)
          ? (tabIndex = 2)
          : window.location.pathname.includes(INSTAGRAM_COLLABORATIONS)
          ? (tabIndex = 1)
          : (tabIndex = 0);
      } else {
        window.location.pathname.includes(INSTAGRAM_MANAGED_CAMPAIGNS)
          ? (tabIndex = 1)
          : (tabIndex = 0);
      }
      setTabs(tabs);
      setSelectedTabIndex(tabIndex);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleNavigateTabs = () => {
    if (tabs.length > 2) {
      if (selectedTabIndex === 0) {
        navigate(INSTAGRAM_MY_CAMPAIGNS);
      } else if (selectedTabIndex === 1) {
        navigate(INSTAGRAM_COLLABORATIONS);
      } else {
        navigate(INSTAGRAM_MANAGED_CAMPAIGNS);
      }
    } else {
      if (selectedTabIndex === 0) {
        navigate(INSTAGRAM_COLLABORATIONS);
      } else {
        navigate(INSTAGRAM_MANAGED_CAMPAIGNS);
      }
    }
  };

  useEffect(() => {
    handleSetInitialTabs();
  }, []);

  useEffect(() => {
    if (isArrayNullOrUndefined(tabs)) return;
    handleNavigateTabs();
  }, [selectedTabIndex, tabs]);

  if (loading) {
    return <></>;
  }

  return (
    <AddFlex
      flexDirection="column"
      padding={isMobileView() ? "0 20px" : "0 48px"}
      margin={isMobileView() ? "0px" : "20px 0"}
      gap="20px"
    >
      <AddFlex>
        <BoxedTabs
          tabs={tabs}
          selectedTabIndex={selectedTabIndex}
          setSelectedTabIndex={setSelectedTabIndex}
        />
        <Gap />
        {getAction()}
      </AddFlex>
      <Outlet /> {/* Dynamic component rendering happens here */}
    </AddFlex>
  );
}

export default InstagramCampagins;
